var map = {
	"./AdobeStock_302682764.png": "60b2",
	"./about-illustration-mobile.png": "a963",
	"./about-illustration-mobile@2x.png": "c306",
	"./about-illustration-mobile@3x.png": "6c99",
	"./about-illustration.png": "2fab",
	"./about-illustration@2x.png": "9d12",
	"./about-illustration@3x.png": "6e33",
	"./bg/business-card.svg": "df7d",
	"./calculator-circle.svg": "2962",
	"./calculator-illustration-1.png": "9e68",
	"./calculator-illustration-1@2x.png": "151d",
	"./calculator-illustration-2.png": "0194",
	"./calculator-illustration-2@2x.png": "abd9",
	"./icons/additional-info-icon.svg": "af73",
	"./icons/address-icon.svg": "61d2",
	"./icons/application_rejected_icon.svg": "5130",
	"./icons/arrow-point-to-right.svg": "554f",
	"./icons/arrow-right-black.svg": "60e4",
	"./icons/attachment.svg": "fe91",
	"./icons/camera.svg": "eae6",
	"./icons/card1.svg": "a11d",
	"./icons/card1hover.svg": "b663",
	"./icons/card2.svg": "9448",
	"./icons/card2hover.svg": "f2d6",
	"./icons/card3.svg": "b80e",
	"./icons/card3hover.svg": "10aa",
	"./icons/card4.svg": "07e76",
	"./icons/card4hover.svg": "eed4",
	"./icons/card5.svg": "825b",
	"./icons/card5hover.svg": "9dfc",
	"./icons/cards/amex.svg": "d88b",
	"./icons/cards/diners-club.svg": "622f",
	"./icons/cards/discover.svg": "9660",
	"./icons/cards/jcb.svg": "e0f3",
	"./icons/cards/mastercard.svg": "e3b8",
	"./icons/cards/unknown-add.svg": "c82a",
	"./icons/cards/unknown.svg": "9831",
	"./icons/cards/visa.svg": "5dbc",
	"./icons/check-ok.svg": "1b82",
	"./icons/circle_caret_up_icon.svg": "cf50",
	"./icons/circle_timer_icon.svg": "d230",
	"./icons/circled-arrow-right-orange.svg": "779c",
	"./icons/circled-arrow-right.svg": "d225",
	"./icons/dots-orange-3x6.svg": "7458",
	"./icons/email.svg": "a96b",
	"./icons/file-upload.svg": "8095",
	"./icons/finances-icon.svg": "a8c7",
	"./icons/flags/denmark.svg": "0db4",
	"./icons/flags/european-union.svg": "17bc",
	"./icons/flags/latvia.svg": "62e0",
	"./icons/flags/mexico.svg": "1af5",
	"./icons/flags/poland.svg": "d03c",
	"./icons/flags/sweden.svg": "81bb",
	"./icons/flags/vietnam.svg": "f75f",
	"./icons/half-circle-lightgray.svg": "af9d",
	"./icons/identity.svg": "2317",
	"./icons/lines-orange-6.svg": "2a0e",
	"./icons/loading_icon.svg": "2027",
	"./icons/logo-black.svg": "9977",
	"./icons/logo-white.svg": "c460",
	"./icons/logo.svg": "aa0d",
	"./icons/maintenance.svg": "cb20",
	"./icons/menu.svg": "3ff5",
	"./icons/news_decoration.svg": "7216",
	"./icons/personal-data-icon.svg": "7e3c",
	"./icons/phone-orange.svg": "b8d1",
	"./icons/profile_logout_icon.svg": "959a",
	"./icons/profile_settings_icon.svg": "2b66",
	"./icons/receive_money_icon.svg": "d5d9",
	"./icons/sf-logo.svg": "3232",
	"./icons/sms-message.svg": "3374",
	"./icons/user-white.svg": "1f68",
	"./icons/why-salem-low-percentage.svg": "ec9f",
	"./icons/why-salem-online.svg": "b291",
	"./icons/why-salem-safe.svg": "32f7",
	"./news_page_boy_article.png": "8914",
	"./news_page_boy_article_full.png": "6b05",
	"./news_page_gerb_article.jpg": "6d33",
	"./news_page_gerb_article_full.jpg": "aea9",
	"./news_page_info_article.png": "93b5",
	"./news_page_info_solidarity.png": "8492",
	"./office.jpg": "6d58",
	"./payment-methods/bank.png": "4237",
	"./payment-methods/kassa24-terminal/1.png": "015c",
	"./payment-methods/kassa24-terminal/2.png": "e607",
	"./payment-methods/kassa24-terminal/3.png": "34dd",
	"./payment-methods/kassa24-terminal/4.png": "5a22",
	"./payment-methods/kassa24-terminal/5.png": "fdf0",
	"./payment-methods/kassa24-terminal/6.png": "7475",
	"./payment-methods/kassa24-terminal/7.png": "144a",
	"./payment-methods/kassa24.png": "7ac1",
	"./payment-methods/online-banking/1.jpg": "765a",
	"./payment-methods/online-banking/2.jpg": "7350",
	"./payment-methods/online-banking/3.jpg": "d77d",
	"./payment-methods/online-banking/4.jpg": "f63c",
	"./payment-methods/online-banking/5.jpg": "3ed0",
	"./payment-methods/processing.png": "b2d3",
	"./payment-methods/processing/kk/1.png": "b906",
	"./payment-methods/processing/kk/2.png": "71c8",
	"./payment-methods/processing/kk/3.png": "b256",
	"./payment-methods/processing/kk/4.png": "fa73",
	"./payment-methods/processing/kk/5.png": "ebfd",
	"./payment-methods/processing/ru/1.png": "eb6f",
	"./payment-methods/processing/ru/2.png": "f7b2",
	"./payment-methods/processing/ru/3.png": "4c38",
	"./payment-methods/processing/ru/4.png": "6334",
	"./payment-methods/processing/ru/5.png": "9f21",
	"./payment-methods/qiwi-terminal/1.jpg": "0a57",
	"./payment-methods/qiwi-terminal/2.jpg": "3a03",
	"./payment-methods/qiwi-terminal/3.jpg": "c9cb",
	"./payment-methods/qiwi-terminal/4.jpg": "7c02",
	"./payment-methods/qiwi-terminal/5.jpg": "be19",
	"./payment-methods/qiwi-terminal/6.jpg": "d69c",
	"./payment-methods/qiwi-wallet/1.jpg": "aa14",
	"./payment-methods/qiwi-wallet/2.jpg": "9926",
	"./payment-methods/qiwi-wallet/3.jpg": "f18a",
	"./payment-methods/qiwi-wallet/4.jpg": "7e2e",
	"./payment-methods/qiwi-wallet/5.jpg": "fc68",
	"./payment-methods/qiwi.png": "da5f",
	"./return-bank.png": "f9da",
	"./return-bank@2x.png": "40a0",
	"./return-bank@3x.png": "78d8",
	"./return-qiwi.png": "0a50",
	"./return-qiwi@2x.png": "499d",
	"./return-qiwi@3x.png": "929c",
	"./return-salem.png": "0e21",
	"./return-salem@2x.png": "d389",
	"./return-salem@3x.png": "8aec",
	"./s8-img1.png": "5865",
	"./s8-img2.png": "59fc",
	"./s8-img3.png": "c806",
	"./s8-img4.png": "810e",
	"./s8-img5.png": "87ed",
	"./small-bissness-illustration.png": "d16f",
	"./small-bissness-illustration@2x.png": "a303",
	"./spinner.svg": "98a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";